import React from 'react';
import I18n from 'i18n-js';

import RecentlyViewedListings from '@reverbdotcom/commons/src/cms/components/recently_viewed_listings';
import MarketplacePageWrapper from '../marketplace/marketplace_page_wrapper';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';

export function HolidaySaleGrid() {
  return (
    <div className="holiday-sale-grid">
      <CmsEmbed
        slug="on-sale-embed"
        ssrMode="static-only"
        renderHeader
      />
      <MarketplacePageWrapper
        hideFollowButtons
        skipHeader
        pageSettings={{
          holidaySale: true,
          useExperimentalRecall: false,
        }}
      />
      <RecentlyViewedListings
        title={I18n.t('discovery.recentlyViewed.title')}
        ssr={false}
      />
    </div>
  );
}
